import { render, staticRenderFns } from "./TabHistoryItem.vue?vue&type=template&id=1ce63849"
import script from "./TabHistoryItem.vue?vue&type=script&lang=js"
export * from "./TabHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./TabHistoryItem.vue?vue&type=style&index=0&id=1ce63849&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports